// extracted by mini-css-extract-plugin
export default {"blazyimg":"BLazyImg-module_blazyimg_f4a7dcfa"};